import React, { ReactElement } from 'react';
import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps as MuiAccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import { ReactComponent as ArrowForwardSharpIcon } from 'new/components/icons/angleSmallRight.svg';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

interface AccordionProps {
  title?: string;
  summary?: ReactElement;
  titleClassName?: string;
  detailsClassName?: string;
}

const StyledAccordion = styled((props: MuiAccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: 'none',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ArrowForwardSharpIcon />} {...props} />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const Accordion = (props: AccordionProps & MuiAccordionProps) => {
  const { title, titleClassName, detailsClassName, summary, children, ...rest } = props;
  return (
    <StyledAccordion {...rest}>
      <AccordionSummary>
        {title ? (
          <Typography variant="overline" className={titleClassName}>
            {title}
          </Typography>
        ) : (
          summary
        )}
      </AccordionSummary>
      <AccordionDetails className={detailsClassName}>{children}</AccordionDetails>
    </StyledAccordion>
  );
};
